import React from "react";
import "./Info.scss";

function Info({ dayPeak }) {
  return (
    <div>
      <div>
        <div className="electricity-info">
          <p>
            {/* <span>
              7 AM - 7 PM – <b>2.47 GW</b>
            </span> */}
            <span>
              7 Day Peak – <b>{dayPeak.value.toFixed(2)} GW </b>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Info;
